"use strict";

var curry3 = require("./curry3.js");

var apply = require("./apply.js");

var juxt = require("./juxt.js");

var go = require("./go.js");

module.exports = curry3(function fork(join, f1, f2, ...args) {
  return go(args, apply(juxt(f1, f2)), apply(join));
});